// services/notification.service.ts

export type NotificationCategory =
  | "Placements"
  | "Internships"
  | "Programs"
  | "General";

export interface NotificationType {
  id: string;
  title: string;
  description: string;
  category: NotificationCategory;
  timestamp: string;
  isRead: boolean;
  type:
    | "placement_confirmed"
    | "internship_application"
    | "vendor_review"
    | "student_enrollment"
    | "program_completed";
}

const DUMMY_NOTIFICATIONS: NotificationType[] = [
  {
    id: "1",
    title: "New Placement Confirmed",
    description:
      "Emma Watson has been placed at Microsoft with a package of $115,000",
    category: "Placements",
    timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(), // 2 hours ago
    isRead: false,
    type: "placement_confirmed",
  },
  {
    id: "2",
    title: "Internship Application",
    description:
      "Alex Johnson has applied for Software Development Intern at Google",
    category: "Internships",
    timestamp: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(), // 4 hours ago
    isRead: false,
    type: "internship_application",
  },
  {
    id: "3",
    title: "Vendor Review Pending",
    description: "TechCorp Solutions vendor contract is pending review",
    category: "General",
    timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(), // 1 day ago
    isRead: true,
    type: "vendor_review",
  },
  {
    id: "4",
    title: "New Student Enrollment",
    description:
      "45 new students have been enrolled in Computer Science department",
    category: "General",
    timestamp: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(), // 2 days ago
    isRead: true,
    type: "student_enrollment",
  },
  {
    id: "5",
    title: "Program Completed",
    description:
      "Effective Communication program has been successfully completed by 60 students",
    category: "Programs",
    timestamp: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(), // 5 days ago
    isRead: true,
    type: "program_completed",
  },
];

const simulateDelay = (ms = 400) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const fetchNotifications = async () => {
  await simulateDelay();
  return DUMMY_NOTIFICATIONS;
};

export const markAllAsRead = async () => {
  await simulateDelay();
  DUMMY_NOTIFICATIONS.forEach((n) => (n.isRead = true));
  return true;
};
